<script setup lang="ts">
/**
 * Tooltip on hover and on keyboard focus. The slotted element is the trigger
 * itself (a single element: a Button, a link, a Tag), so a control reached
 * with Tab shows its tooltip. One TooltipProvider for the whole app (App.vue).
 */
import { TooltipArrow, TooltipContent, TooltipPortal, TooltipRoot, TooltipTrigger } from 'reka-ui'

withDefaults(defineProps<{
  text: string
  side?: 'top' | 'bottom' | 'left' | 'right'
}>(), { side: 'top' })
</script>

<template>
  <TooltipRoot>
    <TooltipTrigger as-child><slot /></TooltipTrigger>
    <TooltipPortal>
      <TooltipContent :side="side" :side-offset="6"
                      class="z-toast max-w-[300px] rounded-[6px] bg-foreground px-2.5 py-1.5
                             text-[12px] leading-[1.45] text-background shadow-md
                             data-[state=open]:animate-in data-[state=open]:fade-in-0 data-[state=open]:zoom-in-[.97] data-[side=bottom]:slide-in-from-top-1 data-[side=top]:slide-in-from-bottom-1 data-[side=left]:slide-in-from-right-1 data-[side=right]:slide-in-from-left-1 data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=closed]:zoom-out-[.97]">
        {{ text }}
        <TooltipArrow class="fill-foreground" :width="10" :height="5" />
      </TooltipContent>
    </TooltipPortal>
  </TooltipRoot>
</template>
